import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories, CMRCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current(CMRCategories).require(basePlanCategories, { licenseMatch: false })];
  }

  async conflicts() {
    return CMRCategories;
  }
}
